import React from 'react';
const EquipmentRentals = () => <div className="service-page"><h1>Equipment Rentals</h1><p>Rent equipment for events, construction, and more.</p></div>;
export default EquipmentRentals;
